import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef } from 'react';

// Source: images/move-to-opening.svg.
export const MoveToOpeningIcon = forwardRef<SVGSVGElement, BaseIconProps>(
  function MoveToOpeningIcon(props, ref) {
    return (
      <BaseIcon
        ref={ref}
        viewBox="0 0 16 16"
        fill="currentColor"
        stroke="none"
        {...props}
      >
        <path d="M12 7H9V9H12V12L16 8L12 4V7Z" />
        <path d="M4 12C6.20914 12 8 10.2091 8 8C8 5.79086 6.20914 4 4 4C1.79086 4 0 5.79086 0 8C0 10.2091 1.79086 12 4 12Z" />
      </BaseIcon>
    );
  },
);
